import { Component, Input, Inject } from '@angular/core';
import { PORTAL_SETTINGS } from '../../../core/token/base-config.token';
import { PortalSettings } from '../../../core/types/base-portal-settings.type';

@Component({
  selector: 'base-legal-document-links',
  templateUrl: './base-legal-document-links.component.html',
})
export class BaseLegalDocumentLinksComponent {
  @Input() increasedFontSize: boolean = false;

  constructor(@Inject(PORTAL_SETTINGS) private portalConfig: PortalSettings) {}

  get portalSettings(): PortalSettings {
    return this.portalConfig;
  }

  trackByLink(_: number, item: string) {
    return item;
  }
}
